import { render, staticRenderFns } from "./PermissionsUpdate.vue?vue&type=template&id=03f67a1c"
import script from "./PermissionsUpdate.vue?vue&type=script&lang=js"
export * from "./PermissionsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports